import { Store } from '@tanstack/store';
import { DateTime } from 'luxon';

import Enums from './types/api/Enums';
import { NewUserInfo, type UserInfo } from './types/api/UserInfo/UserInfo';
import { Units } from './types/units';

type DefaultMargins = {
  targetMarginFlatAmount: string;
  minimumMarginFlatAmount: string;
  targetMarginPercentage: string;
  minimumMarginPercentage: string;
};
interface ConfigurationState {
  userInfo: UserInfo;
}

const initialState: ConfigurationState = {
  userInfo: NewUserInfo({}),
};

const configurationStore = new Store(initialState);

export const setUserInfo = (userInfo: UserInfo): void => {
  configurationStore.setState((prev: ConfigurationState) => ({
    ...prev,
    userInfo,
  }));
};

export const getUserInfo = (): UserInfo => configurationStore.state.userInfo;

export const getTenantUnits: () => Units = () => {
  return {
    dryVolume: configurationStore.state.userInfo.tenant.defaultDryVolumeUnit,
    wetVolume: configurationStore.state.userInfo.tenant.defaultWetVolumeUnit,
    length: configurationStore.state.userInfo.tenant.defaultLengthUnit,
    area: configurationStore.state.userInfo.tenant.defaultAreaUnit,
    weight: configurationStore.state.userInfo.tenant.defaultWeightUnit,
    strength: configurationStore.state.userInfo.tenant.defaultStrengthUnit,
    locale: configurationStore.state.userInfo.tenant.locale,
    other: configurationStore.state.userInfo.tenant.defaultOtherUnit,
    currencyCode: configurationStore.state.userInfo.tenant.defaultCurrencyCode,
  };
};

// The zone personal dates and times are shown and entered in; the tenant's until users can pick one.
// New York when unset, matching the server's activity sort and reminder triggers.
export const getDisplayTimezone = (): string =>
  configurationStore.state.userInfo.tenant.timezone ?? 'America/New_York';

export const getTenantTimezone = (): string =>
  configurationStore.state.userInfo.tenant.timezone ?? 'UTC';

export const getTenantTodayISO = (): string =>
  DateTime.now().setZone(getTenantTimezone()).toISODate() ?? '';

export const getUserSetting = (key: Enums.UserSettingKey, defaultValue: string): string => {
  const settingsValue = configurationStore.state.userInfo.settings.find((it) => it.key === key);

  return settingsValue ? settingsValue.value : defaultValue;
};

export const getDefaultMargins = (): DefaultMargins => {
  const tenant = configurationStore.state.userInfo.tenant;

  return {
    targetMarginFlatAmount: tenant.targetMarginFlatAmount,
    minimumMarginFlatAmount: tenant.minimumMarginFlatAmount,
    targetMarginPercentage: tenant.targetMarginPercentage,
    minimumMarginPercentage: tenant.minimumMarginPercentage,
  };
};

export const getMarginConfiguration = (): Enums.MarginConfiguration => {
  return configurationStore.state.userInfo.tenant.marginConfiguration;
};
